/* Product-specific two-line headings for current new-format stories in draft theme 198206619981. */
(() => {
  const overrides = {
  "43020": {"hero":["World Trophy.","Ready to Glow."],"life":null},
  "43032": {"hero":["World Cup 2026.","Colours Rise."],"life":null},
  "76354": {"hero":["Helicarrier.","Mission Ready."],"life":null},
  "43023": {"hero":["Lando's Race.","Helmet Aglow."],"life":["Race at Rest.","Display Aglow."]},
  "43022": {"hero":["Hamilton.","Helmet Aglow."],"life":["Race Day Ends.","Glow Stays."]},
  "43017": {"hero":["Papaya Helmet.","Under Lights."],"life":["Piastri's Glow.","After Dark."]},
  "75455": {"hero":null,"life":["Hunter Waits.","Lights Awake."]},
  "11382": {"hero":["Hubble's View.","Space Aglow."],"life":["Room Grows Still.","Cosmos Glows."]},
  "77263": {"hero":["BMW M3 Lights.","After Dark."],"life":["Race at Rest.","Glow Stays."]},
  "75459": {"hero":null,"life":["Shuttle Arrives.","After Dark."]},
  "11386": {"hero":["Bikini Bottom.","Colour Glows."],"life":null},
  "43026": {"hero":null,"life":["Court Is Quiet.","Icon Shines."]},
  "72306": {"hero":["PlayStation.","Memories Glow."],"life":["Games Stay.","Memories Glow."]},
  "11379": {"hero":null,"life":["Quiet Corner.","Long Evening."]},
  "76352": {"hero":["Tower at Night.","Heroes Answer."],"life":["City at Rest.","Lights Stay On."]},
  "71043": {"hero":["Hogwarts.","Castle Glows."],"life":null},
  "75438": {"hero":null,"life":null},
  "75461": {"hero":null,"life":null},
  "75419": {"hero":null,"life":null},
  "72051": {"hero":null,"life":null},
  "43014": {"hero":null,"life":null},
  "21368": {"hero":null,"life":null},
  "10216": {
    "hero": [
      "Village Bakery.",
      "Window Glows."
    ],
    "life": [
      "Warm Window.",
      "Bakery at Night."
    ]
  },
  "10228": {
    "hero": [
      "Haunted House.",
      "Never Sleeps."
    ],
    "life": null
  },
  "10245": {
    "hero": null,
    "life": [
      "Santa's Workshop.",
      "Lights Shine."
    ]
  },
  "10249": {
    "hero": null,
    "life": [
      "Christmas Square.",
      "Toy Shop Glows."
    ]
  },
  "10254": {
    "hero": [
      "Winter Train.",
      "All Aboard."
    ],
    "life": [
      "Christmas Rail.",
      "Tree Travels."
    ]
  },
  "10259": {
    "hero": [
      "Village Station.",
      "Bus Arrives."
    ],
    "life": [
      "Last Stop.",
      "Village Glows."
    ]
  },
  "10263": {
    "hero": null,
    "life": [
      "Village Station.",
      "Christmas Dusk."
    ]
  },
  "10267": {
    "hero": [
      "Gingerbread.",
      "Candy Glows."
    ],
    "life": [
      "Sweet Winter.",
      "House Aglow."
    ]
  },
  "10273": {
    "hero": [
      "Haunted Manor.",
      "Thrills Await."
    ],
    "life": [
      "Fairground Rests.",
      "Manor Stirs."
    ]
  },
  "10275": {
    "hero": [
      "Elf Club.",
      "Holiday Glow."
    ],
    "life": [
      "After the Rush.",
      "Home Aglow."
    ]
  },
  "10290": {
    "hero": [
      "Red Pickup.",
      "Wreath on Front."
    ],
    "life": [
      "Red Truck Home.",
      "Lights Aglow."
    ]
  },
  "10293": {
    "hero": null,
    "life": [
      "Stockings Ready.",
      "Eve Aglow."
    ]
  },
  "10294": {
    "hero": [
      "Titanic at Rest.",
      "Lights Endure."
    ],
    "life": [
      "Ocean Liner.",
      "Evening Aglow."
    ]
  },
  "10300": {
    "hero": [
      "DeLorean Ready.",
      "Future Awaits."
    ],
    "life": [
      "Time Machine.",
      "Another Night."
    ]
  },
  "10307": {
    "hero": [
      "Iron Paris.",
      "Tower Aglow."
    ],
    "life": null
  },
  "10308": {
    "hero": [
      "Main Street.",
      "Shops Aglow."
    ],
    "life": [
      "Last Tram.",
      "Street Lights Up."
    ]
  },
  "10316": {
    "hero": [
      "Rivendell.",
      "Valley Aglow."
    ],
    "life": [
      "Valley at Rest.",
      "Stay Awhile."
    ]
  },
  "10318": {
    "hero": [
      "Concorde Rises.",
      "Evening Flight."
    ],
    "life": [
      "Flight at Rest.",
      "Wonder Stays."
    ]
  },
  "10325": {
    "hero": [
      "Alpine Lodge.",
      "Snow Outside."
    ],
    "life": [
      "Home from Snow.",
      "Stay Awhile."
    ]
  },
  "10326": {
    "hero": [
      "Museum at Night.",
      "Discover More."
    ],
    "life": [
      "Same Museum.",
      "After Dark."
    ]
  },
  "10333": {
    "hero": [
      "Sauron Watches.",
      "Tower Glows."
    ],
    "life": [
      "Mordor at Night.",
      "Room Holds Still."
    ]
  },
  "10339": {
    "hero": [
      "Santa's Post.",
      "Letters Arrive."
    ],
    "life": [
      "Post Is Sorted.",
      "Christmas Stays."
    ]
  },
  "10340": {
    "hero": [
      "Winter Wreath.",
      "Welcome Glows."
    ],
    "life": [
      "Wreath Is Ready.",
      "Winter Glows."
    ]
  },
  "10341": {
    "hero": [
      "Artemis Ready.",
      "Count to Launch."
    ],
    "life": [
      "Rocket at Rest.",
      "Launchpad Glows."
    ]
  },
  "10350": {
    "hero": [
      "Tudor Corner.",
      "Windows Aglow."
    ],
    "life": null
  },
  "10354": {
    "hero": [
      "Bilbo's Party.",
      "Fireworks Glow."
    ],
    "life": [
      "Bag End at Rest.",
      "Lights Remain."
    ]
  },
  "10356": {
    "hero": [
      "Enterprise Ready.",
      "Next Mission."
    ],
    "life": [
      "Same Starship.",
      "New Presence."
    ]
  },
  "10361": {
    "hero": [
      "Holiday Express.",
      "Christmas Rides."
    ],
    "life": [
      "Christmas Rail.",
      "Platform Awaits."
    ]
  },
  "10365": {
    "hero": [
      "Jack's Ship.",
      "Lanterns Lead."
    ],
    "life": [
      "Ship at Anchor.",
      "Night at Sea."
    ]
  },
  "11370": {
    "hero": [
      "Creel House.",
      "Hawkins Stirs."
    ],
    "life": [
      "Quiet Room.",
      "House Unsettled."
    ]
  },
  "11374": {
    "hero": [
      "Pinball Arcade.",
      "Lights at Play."
    ],
    "life": [
      "Arcade at Rest.",
      "Playfield Glows."
    ]
  },
  "11376": {
    "hero": [
      "Model T at Dusk.",
      "Vintage Glow."
    ],
    "life": [
      "Vintage Car.",
      "Warm New Hour."
    ]
  },
  "11380": {
    "hero": [
      "Road Bike at Dusk.",
      "Frame Aglow."
    ],
    "life": [
      "Quiet Ride.",
      "Frame Glows."
    ]
  },
  "11381": {
    "hero": [
      "Jaguar E-Type.",
      "Curves Aglow."
    ],
    "life": null
  },
  "11383": {
    "hero": [
      "Midnight Manor.",
      "Mood Sets In."
    ],
    "life": [
      "After Midnight.",
      "Look Again."
    ]
  },
  "11387": {
    "hero": [
      "Holiday House.",
      "Lights Welcome."
    ],
    "life": [
      "Evening Settles.",
      "Warmth Stays."
    ]
  },
  "11505": {
    "hero": [
      "Woodland Glow.",
      "Small Wonders."
    ],
    "life": [
      "Forest at Rest.",
      "Colours Stay."
    ]
  },
  "21061": {
    "hero": [
      "Notre-Dame.",
      "Paris in Light."
    ],
    "life": [
      "Paris at Rest.",
      "Light Remains."
    ]
  },
  "21341": {
    "hero": [
      "Cottage Awake.",
      "Salem Stirs."
    ],
    "life": [
      "Little Salem.",
      "Close to Home."
    ]
  },
  "21351": {
    "hero": [
      "Halloween Town.",
      "Seasons Meet."
    ],
    "life": [
      "Same Town.",
      "New Evening."
    ]
  },
  "21357": {
    "hero": [
      "Meet Luxo Jr.",
      "Little Lamp Glows."
    ],
    "life": [
      "Familiar Pose.",
      "Brighter Spirit."
    ]
  },
  "21369": {
    "hero": [
      "Case Unclosed.",
      "Night Begins."
    ],
    "life": [
      "Quiet Room.",
      "Case Stays Open."
    ]
  },
  "21370": {
    "hero": [
      "E.T. Returns.",
      "A Warm Glow."
    ],
    "life": [
      "Familiar Face.",
      "Warm Welcome."
    ]
  },
  "21371": {
    "hero": [
      "Wallace. Gromit.",
      "Adventure Awaits."
    ],
    "life": [
      "Quiet Room.",
      "Adventure Stays."
    ]
  },
  "21373": {
    "hero": [
      "Downton Glows.",
      "Stories Remain."
    ],
    "life": null
  },
  "31212": {
    "hero": [
      "Milky Way.",
      "Stars Aglow."
    ],
    "life": [
      "Same Galaxy.",
      "After Dark."
    ]
  },
  "40223": {
    "hero": [
      "Snowglobe.",
      "Winter Glows."
    ],
    "life": [
      "Little Christmas.",
      "Evening Glow."
    ]
  },
  "40292": {
    "hero": [
      "Holiday Present.",
      "A Room Inside."
    ],
    "life": [
      "Surprise at Night.",
      "Room Shines."
    ]
  },
  "40338": {
    "hero": null,
    "life": [
      "Little Tree.",
      "Warm Christmas."
    ]
  },
  "40484": {
    "hero": [
      "Santa's Yard.",
      "Snow at Dusk."
    ],
    "life": null
  },
  "40499": {
    "hero": [
      "Santa's Sleigh.",
      "Ready to Fly."
    ],
    "life": [
      "Presents Packed.",
      "Sleigh Aglow."
    ]
  },
  "40571": {
    "hero": [
      "Winter Bears.",
      "Sleigh Ride."
    ],
    "life": null
  },
  "40573": {
    "hero": [
      "Christmas Tree.",
      "Ornaments Glow."
    ],
    "life": [
      "Table Is Ready.",
      "Trees Still Glow."
    ]
  },
  "40658": {
    "hero": null,
    "life": [
      "Falcon Holiday.",
      "Party Glows."
    ]
  },
  "40743": {
    "hero": [
      "Christmas Table.",
      "Lights Gather."
    ],
    "life": [
      "Table Is Set.",
      "Lights Gather."
    ]
  },
  "40806": {
    "hero": [
      "Sweet AT-AT.",
      "Holiday Glow."
    ],
    "life": [
      "Christmas Lights.",
      "AT-AT Glows."
    ]
  },
  "40825": {
    "hero": [
      "Wreath with Bite.",
      "Colours Glow."
    ],
    "life": [
      "Visitors Arrive.",
      "Wreath Is Ready."
    ]
  },
  "40874": {
    "hero": [
      "Christmas Near.",
      "Count It Down."
    ],
    "life": null
  },
  "40958": {
    "hero": [
      "Stocking Hung.",
      "Warm Glow."
    ],
    "life": [
      "Cozy Corner.",
      "Stocking Glows."
    ]
  },
  "41843": {
    "hero": [
      "Family Tree.",
      "World Within."
    ],
    "life": null
  },
  "42210": {
    "hero": [
      "Skyline at Night.",
      "Spotlight Ready."
    ],
    "life": [
      "Skyline at Rest.",
      "Car Lights Up."
    ]
  },
  "42232": {
    "hero": [
      "Sadair's Spear.",
      "Red Lines Glow."
    ],
    "life": [
      "Sharp Outline.",
      "Colours Arrive."
    ]
  },
  "43197": {
    "hero": [
      "Ice Palace.",
      "Winter Aglow."
    ],
    "life": [
      "Palace at Home.",
      "Ice Catches Light."
    ]
  },
  "43222": {
    "hero": [
      "Disney Castle.",
      "Story Lingers."
    ],
    "life": [
      "Same Castle.",
      "New View."
    ]
  },
  "75192": {
    "hero": [
      "Falcon Aglow.",
      "Ready to Fly."
    ],
    "life": [
      "One More Jump.",
      "Evening Awaits."
    ]
  },
  "75810": {
    "hero": [
      "Hawkins Above.",
      "Below, Unknown."
    ],
    "life": [
      "Two Worlds.",
      "One Evening."
    ]
  },
  "76269": {
    "hero": [
      "Avengers Tower.",
      "Heroes Gather."
    ],
    "life": [
      "Headquarters.",
      "Evening View."
    ]
  },
  "76388": {
    "hero": [
      "Hogsmeade Dusk.",
      "Warm in Snow."
    ],
    "life": [
      "Hogsmeade Snow.",
      "Rooms Aglow."
    ]
  },
  "76419": {
    "hero": [
      "Hogwarts Glows.",
      "Castle at Night."
    ],
    "life": [
      "Same Castle.",
      "After Dark."
    ]
  },
  "76780": {
    "hero": [
      "Wednesday.",
      "Details Glow."
    ],
    "life": [
      "Room Falls Quiet.",
      "Details Glow."
    ]
  },
  "76781": {
    "hero": [
      "Two Roommates.",
      "One Window."
    ],
    "life": [
      "Nevermore Night.",
      "Room Relit."
    ]
  },
  "76784": {
    "hero": [
      "Dark Dahlia.",
      "Secret Glow."
    ],
    "life": null
  },
  "76911": {
    "hero": null,
    "life": [
      "Silver DB5.",
      "Evening Mood."
    ]
  },
  "77256": {
    "hero": [
      "Tiny DeLorean.",
      "Huge Leap."
    ],
    "life": null
  },
  "80106": {
    "hero": [
      "Nian at the Gate.",
      "Legend Glows."
    ],
    "life": [
      "Snowy Tale.",
      "Legend Aglow."
    ]
  },
  "80107": {
    "hero": [
      "Lantern Garden.",
      "Festival Night."
    ],
    "life": [
      "Lanterns Glow.",
      "Garden Wakes."
    ]
  },
  "80108": {
    "hero": [
      "Six Traditions.",
      "New Year Glows."
    ],
    "life": [
      "Traditions Stay.",
      "Scenes Shine."
    ]
  },
  "80109": {
    "hero": null,
    "life": [
      "Ice Festival.",
      "Winter Glow."
    ]
  }
};
  const captionOverrides = {
    "43020": [
      "Light follows the curved band above the base, giving the golden silhouette a vivid finish. The ring stands apart from the figures below.",
      "Open the globe to find the small 2026 scene tucked inside the golden form. The light brings this hidden celebration forward within the trophy.",
      "Warm light reaches the figures who hold the world aloft at the top of the trophy. Their raised forms remain visible against the globe.",
      "A cool glow frames the lower display and draws the eye to its nameplate. It gives the base a blue edge beneath the warm gold above."
    ],
    "75438": [
      "Warm light gives Yoda’s expression a gentle focus beneath his shaped brows. The glow draws out the face beside the green blade.",
      "The Yoda minifigure holds its own lit blade beside the larger display. Its small figure echoes the pose and colour of the bust.",
      "A low accent beneath the robe adds depth above the dark display base. It separates the folds of the cloak from the shadows below.",
      "The raised lightsaber glows bright green beside the bust’s watchful face. Its colour gives the scene a clear focus after dark."
    ],
    "43022": [
      "A red glow fills the visor, bringing the face of the helmet into focus. Against the Modena yellow shell, the colour reads clearly from the front.",
      "Small warm lights frame the visor against the Modena yellow shell. Their points of light add depth around the red centre.",
      "Warm light falls across the stand beneath Hamilton’s signature plaque. The display base remains part of the composition after dark.",
      "Look down over the curved yellow shell to the glowing red visor below. This angle shows the contrast between the paint and the deeper light."
    ],
    "43017": [
      "Red light traces the visor beneath the McLaren graphics. The glow follows the front curve and gives the helmet a sharper presence after dark.",
      "Amber light accents the papaya side and 1,000 Grand Prix mark. Both details stay visible against the darker blue of the visor.",
      "Piastri’s blue meets McLaren papaya above the lit visor. The two colours define the helmet from this side as clearly as from the front.",
      "Warm light at the stand draws the eye to Piastri’s number 81. The display base carries that racing detail into the evening view."
    ],
    "43014": [
      "Red light traces the visor against Leclerc’s racing colours. It gives the front of the helmet a clear line of light after dark.",
      "A front view reveals the green-lit visor and helmet shape. The green stands out against the red and white panels around it.",
      "Leclerc’s number 16 sits beside a bright amber side light. The two details share the frame without losing their separate colours.",
      "Amber light shines beside the red and white helmet panels. From this angle, the side details remain visible against the dark."
    ],
    "77263": [
      "Four round headlights shine warm yellow above the M3’s familiar grille. Together they give the little racer a clear front view after dark.",
      "Through the windscreen, a warm glow reveals the cockpit and steering wheel. It brings the driver’s space into view within the car.",
      "Beneath the door graphic, blue lights reflect below the racing stripes. The cool glow gives the side profile a second line of colour.",
      "Under the broad rear wing, red taillights give the little BMW a clear presence. The rear detail holds its own after dark."
    ],
    "43026": [
      "The brick-built Swoosh glows against the sneaker’s sculpted white upper. Its familiar curve becomes a bright detail across the side after dark.",
      "Beneath the shoe, golden light follows the orange and yellow rocket trail. The glow carries the sense of lift-off down to the base.",
      "AF1 lettering shines in blue above the lunar base after dark. The letters give the display a clear finishing mark beneath the shoe.",
      "Inside the sneaker, a warm glow brings the Nike and LEGO® marks together. Both details remain visible through the open upper."
    ],
    "71043": [
      "Tall windows glow above the Great Hall, recalling the first view of Hogwarts across the dark lake. The castle feels ready to welcome you home.",
      "Above the covered bridge, golden windows greet arrivals from the lake. Their warm light draws the eye along the castle walls.",
      "Warm lamps frame the stone archway on the way into Hogwarts, revealing the path and the texture of the walls as the castle settles into night.",
      "Golden points crown the turrets after the rest of the room goes dark. Each tower takes on its own glow against the night."
    ],
    "10341": [
      "White lights shine beside the orange core, drawing your eye to the twin boosters before launch. The bright points give the stack a sense of readiness.",
      "Small bright lamps pick out the platform details below the tower. They trace the working structure that supports the rocket before launch.",
      "Deep red light beneath the boosters adds a final launch-night accent. The glow anchors the stack to the base of the display.",
      "A bright point at the tip draws the eye to the top of the display. From the platform to the peak, the rocket remains clear after dark."
    ],
    "21371": [
      "A warm headlight catches the front mudguard. Against the red bodywork and black housing, it gives the motorbike an unmistakable evening face.",
      null,
      "Red and amber accents pick out the ribbed engine and small parts below. Light gives this compact corner depth while leaving the brickwork in view.",
      "A warm line follows the sidecar curve to the lamp at its nose. Against the red bricks, Gromit’s half of the ride gets its own character."
    ],
    "11505": [
      "White spots and curved edges make a miniature world under the red caps. Warm light meets the green glow of the foliage below.",
      "Two purple crocuses bring another shape to the scene. Light in their centres picks out the layered petals and keeps their colour clear.",
      null, null
    ],
    "10307": [
      "Blue light follows the open ironwork in the Standard lighting group. The added accents give the tower a different rhythm after dark.",
      "White light reaches the upper platform, summit and French flag. This small finishing detail stays visible at the top of the display.",
      "Trees, paths and Parisian details give the tower a human scale. Warm light around the base invites a closer look beneath the silhouette.",
      "The observation platform cuts a clear line through the lattice. Light below reveals the railings, supports and repeating geometry."
    ],
    "10318": [
      "From above, the slender fuselage and delta wings tell the story in one line. White markers and red and green navigation lights trace its outline.",
      "Warm light behind the cockpit glazing gives the sculpted nose a human scale. It invites a closer look at the front of this aircraft.",
      "Two pairs of warm engine lights give the rear view its own signature. Their glow stays within the aircraft’s existing outlets.",
      "A green point of light marks the wing against the dark. Nearby bricks, control surfaces and clean geometry remain part of the scene."
    ],
    "75192": [
      null,
      "Under the removable hull, warm light reveals the main hold’s curved seating and Dejarik table. The room waits between one jump and the next.",
      "Above the weathered panels, the sensor dish becomes a warm point of focus. Its printed details stand against the cool engine light.",
      "Blue-white light traces the rear engine band. Plates, grilles and small mechanical details emerge along the ship’s curve."
    ],
    "21061": [
      "Warm light gathers around the rose window’s intricate pattern. It draws out the small curves and openwork of this Gothic detail.",
      "Light reveals depth between the towers’ narrow columns and openings. Their familiar profile becomes clearer after dark.",
      "Small pools of light lift the arches of three portals from the stone-coloured brickwork. The cathedral’s west entrance gains a quiet presence.",
      "Light beneath the flying buttresses follows their slender curves. The apse’s structural rhythm becomes part of the evening display."
    ]
  };
  /* Full-width feature captions: natural two-line copy for four-photo pages. */
  const captionPolish = {
    "43032": [
      "Colourful numerals frame the trophy at the heart of the emblem, while light catches their raised edges.",
      "A warm accent at the foot draws attention to the small printed FIFA tile beneath the colourful numerals.",
      "Blue, green and red light reveal the raised trophy from the same close angle, each colour changing its outline."
    ],
    "75461": [
      "Small red points pick out Vader’s eyes and the hard edges of his black helmet, giving the mask a striking glow after dark.",
      "Red light reveals the chest controls and the sweep of Vader’s cape against his dark armour.",
      "The same close view reveals red, blue, green and yellow light in the raised blade, while Vader’s dark glove holds its hilt."
    ],
    "40958": [null, null, "Pink, blue and green light catches the gold snowflake on the dark green cuff, beside the warm stars."],
    "21357": [
      "Cool white light gives the lamp a fresh look beneath its familiar shade and along its white arm.",
      "A close view reveals light at the foot of the lamp, where the round base meets its articulated arm.",
      "Warm light under the shade gives Luxo Jr. its familiar glow, bringing the small white lamp to life."
    ],
    "11376": [null, "Amber lamps glow beside the cab, drawing the eye toward the split windshield and the dark bodywork behind it."],
    "42232": [
      "Twin red streaks light the front bodywork, following the low contours of the Koenigsegg’s sculpted hood.",
      "White lamps bring the car’s nose into focus, tracing the front light bar against its darker bodywork.",
      "Red lamps outline the back of the car, giving the tail its own sharp profile after dark."
    ],
    "40499": ["Santa rides in the red sleigh with his list and presents behind him. Warm lights pick out its front corners."],
    "10340": [
      "Small red lights pick out the pine cones beside the berries, adding warm colour to the wreath’s green leaves.",
      null,
      "A lit red berry glows among layered leaves and cinnamon details, bringing a festive accent to the wreath."
    ],
    "40292": [
      "Coloured lights gather around the little tree as a guest settles into the blue chair. Wrapped gifts sit nearby.",
      "From above, the little tree and blue chair make a miniature Christmas living room beneath the decorated lid.",
      "A warm fireplace glows between blue curtains, with two green trees standing above the mantel in the other room."
    ],
    "10259": ["Two clock faces sit beneath the steep snowy roof, while a warm glow at the entrance welcomes travellers to the station."],
    "72306": [
      "A green glow beneath the POWER button recalls the small moment that began countless evenings in front of the console.",
      "Warm lights pick out the tiny cars and chequered racing details in the Gran Turismo scene beside the console at night.",
      "Light gathers beneath the palms, revealing Ape Escape’s colourful little world and its playful details beside the console.",
      "Blue light traces the raised disc lid, bringing back the anticipation of choosing the next game for the evening."
    ],
    "21368": [
      "Warm light follows the red roof and familiar nameplate, making this little house feel ready for another Snoopy story.",
      "Light catches Snoopy at his blue typewriter, a quiet rooftop moment with another adventure waiting on the page.",
      "Green light glows among the grass at the base, adding a bright, playful finishing touch to Snoopy’s little world."
    ],
    "11379": [
      "A small lamp waits beside the typewriter, turning the writer’s desk into a quiet place to begin another story tonight.",
      "Warm light frames the upper windows and balcony, where a comfortable chair promises time for another chapter.",
      "Golden light gathers around the café counter, while violet light follows the winding staircase up through the shop.",
      "The little hanging lamp welcomes readers beneath the bookshop sign, a warm detail among the books on the shelf."
    ],
    "76352": [
      null,
      "A green energy blast glows in Doctor Doom’s hand, setting his rooftop silhouette against the tower after dark.",
      "Orange light shines through the Human Torch’s flames, bringing warmth to his pose beside the tower emblem at night.",
      "Blue light reveals the screens and consoles, a quiet pause before the action moves beyond the tower walls and into the city."
    ],
    "21369": [null, null, "Green LEDs trace the forest floor, picking out small paths and foliage beneath the hovering craft at night in the woods."],
    "75419": [null, null, null, "Beyond the great confrontations, smaller rooms hold their own suspense. Light reveals red panels and waiting seats for the next arrival."],
    "76419": [
      "Golden windows brighten the Great Hall facade beneath the towers. Their warm glow carries across the castle after dark.",
      "Cool blue light traces the Black Lake beside the castle. A small ship catches that glow on the dark water below the walls.",
      "Warm lights pick out the courtyard walls and paths. They bring the castle’s stonework into view after dark beneath the towers.",
      "Blue light reveals the hidden chamber beneath the castle. The lower walls take on a cool glow below the towers."
    ],
    "10341": ["White lights shine beside the orange core and twin boosters before launch. Bright points give the rocket stack a sense of readiness."],
    "31212": [
      "Golden points reveal the layered galactic core. Their light draws the eye into the centre of the swirling display of stars.",
      "Pink points brighten the brick-built stars. Their colour contrasts with the dark spiral around the galactic core nearby.",
      "Coloured lights surround the small You Are Here tile. It gives the vast galaxy a human point of reference against the dark.",
      "Blue points extend along the outer galaxy. They carry the eye beyond the bright core and across the dark display."
    ],
    "77256": [
      "White headlights and a blue bumper set the scene for Doc and Marty’s next departure in the little time machine.",
      "Light finds the time calculator inside the cockpit, where Doc and Marty’s next journey is about to begin in the lit car.",
      "Blue light follows the external cables: Doc’s extraordinary idea wrapped around the ordinary car beneath them.",
      "Red lamps glow beneath the rear vents, with the OUTATIME plate waiting between them for another journey after dark."
    ],
    "76911": [
      null,
      "Warm cabin light glows beneath the silver roof, catching a quiet moment before Bond’s next assignment begins.",
      "Red and amber lamps frame the film-themed plate, picking out the rear of Bond’s car as the next chase beckons.",
      "Silver bodywork and wire-style wheels shape the familiar DB5 silhouette, a car made for Bond’s intrigue after dark."
    ],
    "21370": [
      "A red glow at E.T.’s fingertip makes his familiar raised-hand gesture stand out against the darker figure behind it.",
      "Red light shines through E.T.’s chest grille. It draws attention to the centre of the figure beneath his familiar face.",
      "Warm yellow light picks out the flowers beside E.T. Their small pot remains visible next to the softly glowing figure.",
      "Soft light frames E.T.’s eyes and gentle expression. His familiar face remains the focus of the display after dark in this close view."
    ],
    "72051": [
      "Warm light draws the eye to the red Donkey Kong marquee. Its lettering stays clear above the arcade screen.",
      "Lit platforms reveal the ladders and tiny barrels. The arcade level comes into focus behind the glowing details.",
      "Warm control lights surround the black joystick. Its shape stands out against the machine’s front panel below the screen.",
      "Light surrounds the yellow JUMP button. It remains easy to spot among the controls on the arcade cabinet after dark."
    ],
    "11381": [
      "Warm headlamps frame the Jaguar’s curved bonnet. The front profile stands out against the dark around the car.",
      "Warm light reveals the open engine bay. The inline-six remains the focus of this closer view beneath the bonnet.",
      "Warm light reaches the open trunk. It picks out the rear compartment while keeping its curved shape and lid in view.",
      "Cabin light picks out the seats and dashboard. The view reaches beneath the windscreen into the Jaguar’s interior."
    ],
    "11380": [
      "White light marks the handlebar at the front of the bike. It leads the view toward the frame and front wheel after sunset.",
      "Blue light adds a cool accent near the bottle. The close-up keeps that small detail beside the bike frame in view from the side.",
      "A red lamp marks the rear of the bike. Its small point of light defines the back wheel area as the bike rests after dark.",
      "Small coloured lights sit by the front hub. The wheel stays clear around their glow and the slender spokes at the front."
    ],
    "21341": [null, "The translucent plume catches a vivid pink-purple glow against grey bricks, bringing the cottage chimney into focus."],
    "10273": [null, null, "Two warm lanterns mark the entrance, with amber windows and a green arch welcoming visitors to the manor after dark."],
    "11383": [null, "A glowing fireplace, red armchair and framed artwork give this room a warmer mood than the manor’s cool facade."],
    "11370": ["White headlights and cabin light pick out the blue WSQK radio van and its bright side graphics in Hawkins after dark."],
    "21351": [
      "Spiral Hill curls against the yellow moon, with Jack and Sally above the graveyard at the centre of Halloween Town.",
      null, null,
      "Cool light picks out the eye on Jack’s door and the gate beyond, even in this close view of the crooked house after dark."
    ],
    "75810": [null, null, null, "The display plaque and characters sit before the house, with tiny handheld lights completing the search scene in Hawkins."],
    "10228": [
      "Boarded windows shape the tower; green eave light and warm windows trace its steep roof against the night.",
      "The copper tub and small furnishings sit in a green glow, revealing a strange domestic scene inside the house.",
      "Green light gathers by the iron gate as warm windows hint at life inside the boarded house beyond it on a dark night.",
      "Green light reveals the old stove, shelves and small kitchen pieces inside this unusual house after dark beneath the tower."
    ],
    "76781": [
      "Blue light follows the balcony beneath the gargoyles, contrasting with the warmer glow on its pale railing outside the room.",
      null,
      "A white hanging lamp reveals the darker furnishings on Wednesday’s side and the details beneath the dorm roof."
    ],
    "10254": [null, null, null, "Warm windows glow in the red caboose as coloured lights trace its white garland at the end of the winter train."],
    "10308": [
      "A rabbit waits behind the toy-shop glass as colourful garland lights brighten the snowy storefront on Main Street.",
      "Guitars, red awnings and a blue door pick up the music shop’s warm evening glow along the festive street.",
      "The street clock glows beside the decorated streetcar, marking one last stop before Christmas on Main Street.",
      "Enhanced lighting adds glowing ornaments and a lit star; Classic wraps the tree in micro-lights across its branches."
    ],
    "80106": [
      "Two bright fireworks rise above the snowy courtyard, bringing colour to the night of Nian’s arrival at the house below.",
      null,
      "A close view reveals warm light under the roof and beside the firecracker strings at the decorated doorway below."
    ],
    "80107": ["Red lanterns lead towards the ox, while cool light circles the moon gate and draws the garden path into view at night."],
    "80109": [
      "Cool blue light runs through the clear centrepiece while red festival lanterns glow on either side of the gate at night.",
      "Skaters move across the frozen lake beneath the lit sculpture, with tiny white lights tracing the ice edge at night.",
      "Small coloured lights catch the snow-covered branches while the festival glows softly beyond the winter trees.",
      "The equipment shop, photo booth and lantern-lined ice share one snowy scene, lively from every angle after dark."
    ]
  };
  /* Complete short six-card captions with verified, product-specific copy. */
  const sixCaptionReplacements = {
    "lego-s-h-i-e-l-d-helicarrier-76354-light-kit": [
      "Cool blue light outlines both circular lift fans against the Helicarrier’s dark hull below.",
      "Warm light inside the aft rotor housing gives the rear hull another point of depth.",
      "The little Quinjet’s lit engine shines above the runway on the Helicarrier’s main flight deck.",
      "Small yellow lights trace the busy runway toward the aircraft waiting near the bridge.",
      "A lit control area rises above the runway, watching over the aircraft and flight deck below.",
      "Amber light glows inside the rear rotor housing, beyond the blue-lit fans across the hull."
    ],
    "lego-boba-fett-75455-light-kit": [
      null,
      "Warm light fills the yellow knee plates, with red accents beside Boba Fett’s dark armour.",
      null,
      "A green chest light picks out the plates of Boba Fett’s armour against the darker suit after dark.",
      "Small warm spotlights wash the sandy base beneath the bounty hunter’s boots and armour.",
      "Red light catches the jetpack’s rocket and rear fittings against Boba Fett’s dark armour."
    ],
    "lego-hubble-space-telescope-11382-light-kit": [
      "Warm light follows the telescope’s silver body, separating its reflective shell from the dark.",
      "The slender antenna and small dish catch warm light beside the telescope’s broad solar arrays.",
      "Cool blue light reveals the equipment bay beneath the telescope’s open silver panels.",
      "Bright blue points mark the corners of both broad, dark solar arrays beside the telescope.",
      "Two warm lights frame the NASA and ESA mission plaque between the telescope’s silver panels.",
      "Three cosmic pictures glow blue beneath the telescope, beside its reflective silver shell."
    ],
    "lego-imperial-lambda-class-shuttle-75459-light-kit": [
      null,
      "The open passenger hatch reveals a warm-lit cabin behind the shuttle’s pale hull.",
      "Red cannon details stand out beside the shuttle’s wide white wings and pale outer hull.",
      "Cool blue light fills the rear engine panels against the shuttle’s pale bodywork after dark.",
      "A small red beacon crowns the central fin above the shuttle’s warm-lit folded wings.",
      "Warm light catches the rear hull panels while cool blue marks the engine housing behind them."
    ],
    "lego-spongebob-squarepants-bikini-bottom-11386-light-kit": [
      "Blue light welcomes SpongeBob at the ship-wheel door beneath the pineapple windows.",
      "Pink light falls across Patrick’s sweet treat inside the little room beneath his rock.",
      "Cool blue light fills Squidward’s windows behind the carved face of his stone house.",
      null,
      "Pink jellyfish shine over the green seabed, floating through this view of Bikini Bottom.",
      "Green light brightens the pineapple crown, outlining SpongeBob’s home against the dark sea."
    ],
    "lego-home-alone-21330-light-kit-christmas-edition": [
      "Warm light reaches the snowy porch steps, front-door wreath and festive garland, giving the McCallister entrance its own glow against the dark house exterior.",
      "Light catches Kevin’s treehouse door and platform above the dark yard at night.",
      "A bedside lamp reveals Kevin’s attic bed and battle plan, making this small room under the roof visible above the rest of the house.",
      "Cool turquoise light frames the bathroom sink and mirror, setting Kevin’s famous moment apart from the warm rooms.",
      "Small warm lights trace the window frame, bringing one festive pane forward against the dark McCallister house exterior while the surrounding wall recedes.",
      "Blue light fills the Oh-Kay van’s cabin while white headlights shine ahead, separating the vehicle outside from the warm house lights behind it."
    ],
    "lego-home-alone-21330-light-kit": [
      "On Remote and Remote + Sound, the red doorbell glows beneath the front-door wreath, adding a bright point to the snowy McCallister porch and its dark exterior.",
      "Light catches Kevin’s treehouse door and platform above the dark yard at night.",
      "Remote and Remote + Sound add a bright star above the decorated tree, with presents and warm light below in the McCallister house.",
      "Two warm lamps frame the back door and snowy steps, standing out against the cool rear wall of the house after dark.",
      "Remote and Remote + Sound light the hearth beneath the hanging stockings, turning the fireplace into the McCallister living room’s warm centre after dark.",
      "Blue light fills the Oh-Kay van’s cabin while white headlights shine ahead, separating the vehicle outside from the warm house lights behind it."
    ],
    "lego-downton-abbey-21373-light-kit": [
      "Warm candlelight falls across the dining table, drawing out its chairs and glassware.",
      "The lit arch frames Downton’s crest above green seating and flowers in the main hall.",
      "The fireplace glows beside red chairs and the library’s long rows of bookshelves after dark.",
      "Warm lamps pick out cookware, shelves and the kitchen’s busy worktable below stairs.",
      "Warm light settles on the desk and small accessories in Mr Carson’s office after dark.",
      "Little warm lights nestle in the cedar branches above a bench in the quiet garden after dark."
    ],
    "lego-the-lord-of-the-rings-minas-tirith-11377-light-kit": [
      null,
      null,
      "Light crowns Gondor’s great gate; its warm arches stand against the pale outer walls.",
      null,
      "The lit stair draws you upward between stone levels, toward the citadel awaiting its king.",
      "The high throne and table glow in the great hall, awaiting Aragorn’s return to Gondor."
    ],
    "lego-the-lord-of-the-rings-barad-dur-10333-light-kit": [
      "Fire-coloured light surrounds the Eye above the black tower as Sauron watches below.",
      "Amber torches break up the stronghold’s black walls as Mordor threatens the Fellowship.",
      "Green light catches letters, scrolls and the desk in the Mouth of Sauron’s study after dark.",
      "The palantír glows before the map, revealing Sauron’s view beyond the dark walls.",
      "Red light reaches beneath the Dark Lord’s throne, giving the lower fortress walls depth.",
      "Warm light finds the long feast table below the throne. Even Mordor has hungry mouths."
    ],
    "lego-the-lord-of-the-rings-the-shire-10354-light-kit": [
      "Warm windows frame Bilbo’s round green door at Bag End, ready for Gandalf’s arrival.",
      "The birthday cake and its candles shine for Bilbo’s eleventy-first, before his farewell.",
      "The red firework dragon rises over Bilbo’s party, recalling Merry and Pippin’s fright.",
      "Warm light falls across Bilbo’s desk and hearth inside Bag End as his next chapter waits.",
      "Lights in the Party Tree gather above Bilbo’s birthday sign before his great farewell.",
      "A teapot, cup and map wait in Bag End’s lamplight. Even an adventure can wait a little."
    ],
    "lego-back-to-the-future-time-machine-10300-light-kit": [
      "Gull-wing doors rise over the lit cabin, leaving a seat ready for Doc and Marty’s next trip.",
      "Gold-lit wheels and red rear lamps frame Doc’s time-travelling DeLorean from behind.",
      "The headlights pick out the silver nose as Doc’s time machine faces the dark ahead.",
      "The warm cabin and seats wait beneath raised gull-wing doors for another trip through time.",
      "Red lamps frame the OUTATIME plate beneath the DeLorean’s tall rear vents after dark.",
      "Classic lights the headlights and cabin, leaving the DeLorean’s wheels dark in this view."
    ],
    "lego-star-trek-u-s-s-enterprise-ncc-1701-d-10356-light-kit": [
      "Blue nacelles carry the eye beyond the saucer as the Enterprise readies for warp.",
      "Above the broad saucer, the lit bridge waits for Picard’s next command after dark.",
      "The blue deflector shines beneath the saucer, facing the darkness beyond the bow.",
      "Small lit windows beneath the saucer suggest a crew awake aboard between missions.",
      "Red nacelle caps stand apart from the long blue housings of Starfleet’s flagship.",
      "Points of light trace the broad saucer and bring the Enterprise’s upper profile into view."
    ],
    "lego-captain-jack-sparrows-pirate-ship-10365-light-kit": [
      "Warm lights trace Jack’s weathered dark hull as his ship slips into view after dark.",
      "A lone amber lantern glows beside the dark rigging during a watchful night on deck.",
      "The lit skull flag stands out against the sails above, leaving little doubt who sails here.",
      "Warm light catches the black sails rising above the deck of Jack’s unmistakable ship.",
      null,
      "Blue light beneath the hull suggests dark water and gives Jack’s ship another edge."
    ],
    "lego-avengers-tower-76269-light-kit": [
      "The blue Avengers emblem shines high above the city as the team assembles below.",
      null,
      "Blue light fills the lab and keeps Loki’s scepter in focus as the team studies it after dark.",
      null,
      null,
      "Cool light picks out the Quinjet on its landing platform beside the tower on a dark night."
    ],
    "lego-disney-castle-43222-light-kit": [
      null,
      "A slipper and pumpkin coach remain visible beside Cinderella’s portrait in the warm light.",
      null,
      "Warm torches lead past the arches and carry the view deeper into the castle hall at night.",
      "Beyond the lit bedroom, Sleeping Beauty’s spinning wheel waits in the tower room.",
      "The glowing chandelier draws the eye to the hall and invites one more dance tonight."
    ],
    "lego-tudor-corner-10350-light-kit": [
      "Beneath the steep gable, warm light frames the little attic window and its brickwork.",
      "Beside the doorway, pink light picks out small flowers and green leaves against the Tudor wall.",
      "Roman numerals and clock hands stand out in the street clock’s warm ring above the corner.",
      "The tall menu board catches blue light between the restaurant’s warm street-level windows.",
      null,
      null
    ],
    "lego-natural-history-museum-10326-light-kit": [
      "Light catches the space-themed banner between the museum’s pale columns at the front entrance.",
      "Beneath the dark roof, warm light picks out the arched attic window and the stonework around it.",
      "Pink points shine among pale blossoms beside the museum’s green wall and stone walkway.",
      "Between tall pale columns, warm lamps welcome visitors at the museum’s central entrance.",
      "The upstairs desk and chair emerge in warm light beneath the museum’s sloping roof.",
      "A warm streetlamp shines beside the blossom tree and the museum’s green façade after dusk."
    ],
    "lego-arcade-pinball-machine-11374-light-kit": [
      "Blue lights frame the space artwork above the green playfield ramp on the backboard.",
      "Small amber and red lights shine above the white flippers, picking out the centre of play.",
      "A bright blue ring circles the side dial, standing out against the dark arcade cabinet.",
      "Blue light traces the playfield rail beside the clear green ramp and dark cabinet edge.",
      "Yellow, amber and red lights form a bright row across the playfield toward the flippers.",
      "A small green light marks the cabinet edge beside the clear blue rail and dark side panel."
    ],
    "lego-2-fast-2-furious-nissan-skyline-gt-r-r34-car-42210-light-kit": [
      "The Skyline’s silver nose and blue stripes catch white headlight glow along the low front.",
      "The grille catches amber light above the blue-and-silver bumper at the Skyline’s nose.",
      "Beneath the side sill, blue underglow spreads under the Skyline’s stripes and silver body.",
      "The raised spoiler sits above red rings marking the rear lamps on the silver Skyline.",
      "A warm exhaust tip glows below the rear lamp and silver bumper, adding one amber accent.",
      "Between the car’s structural beams, red light picks out the lower chassis beneath the Skyline."
    ],
    "lego-santas-post-office-10339-light-kit": [
      "Warm lanterns greet Santa beneath the snowy porch, beside the post office’s striped pillars.",
      "Coloured lights shine through the little tree and the presents gathered beneath its branches.",
      "Tiny lights catch red flowers and green leaves above the snowy post office window on the front wall.",
      "A small grey spotlight lights the red postbox and snowy step beside the entrance at the front door.",
      "Purple light glows under the chimney cap, just above its bright red bow and snowy roof.",
      "Golden light fills the balloon basket beneath its broad canopy beside the snowy post office."
    ],
    "lego-alpine-lodge-10325-light-kit": [
      "Below the Two Pines Inn sign, Remote lights warm red flowers against the snowy lodge wall.",
      "Both versions light the blue rink beside the snowy bridge, where a tiny skater takes a lap.",
      "Beneath the snowy roof, Remote flames light the beds and doorway in the lodge’s upper room.",
      "Red flowers catch Remote light beside the shared roof lighting and snow-covered eaves.",
      "The fireplace and cosy seating glow with Remote lighting in the lodge’s warm interior after dark.",
      "Four original colour views show the little tree in a different shade beneath snowy branches."
    ],
    "lego-family-christmas-tree-41843-light-kit": [
      "Five colour views show clear points and gold tips around the glowing star high in the tree.",
      "Cool white light traces the green branch above the red bauble and its golden rim near the tree base.",
      "Inside the tree, a tiled floor and black stool emerge in warm light among the branches.",
      "Behind the branches, Santa’s screen and green map catch warm light in the tiny room.",
      "A red bauble glows beneath the tree’s curved green branches and gold-tipped layers.",
      "Inside the red base, warm light reveals the blue-and-gold train nestled among the branches."
    ],
    "lego-holiday-express-train-10361-light-kit": [
      "The gold Holiday Express plate glows below blue lamps over the engine’s dark boiler.",
      "White light catches the brick-built steam above the engine’s gold trim and dark boiler.",
      "A warm wreath glows beneath the tender’s purple lamp, framed by its curved gold rail.",
      "Purple light fills the tender lantern inside its bright gold railing above the decorated side.",
      "Warm lamps fill the gift carriage while blue light reaches the rails and track beneath its wheels.",
      "Warm light falls on the snowy platform bench beside a red-and-green wreath at the stop."
    ]
  };
  const sixCaptionMobileReplacements = {
    "lego-home-alone-21330-light-kit-christmas-edition": [
        "Warm light catches the porch steps and garland beneath the wreath at the front door.",
        "Light catches Kevin’s treehouse door and platform above the dark yard at night.",
        "A bedside lamp reveals the attic bed beside Kevin’s carefully laid battle plan under the roof.",
        "Cool turquoise light frames the bathroom sink and mirror for Kevin’s famous moment.",
        "Little warm lights trace the window frame against the dark McCallister house exterior.",
        "Blue light fills the Oh-Kay van’s cabin while its white headlights shine ahead outside."
    ],
    "lego-home-alone-21330-light-kit": [
        "In Remote and Remote + Sound, a red doorbell glows beneath the front-door wreath.",
        "Light catches Kevin’s treehouse door and platform above the dark yard at night.",
        "Remote and Remote + Sound add a bright star above the decorated tree and presents below.",
        "Two warm lamps frame the back door and snowy steps against the cool rear wall.",
        "Remote and Remote + Sound light the hearth beneath the hanging stockings in the living room.",
        "Blue light fills the Oh-Kay van’s cabin while its white headlights shine ahead outside."
    ]
};
  const handle = location.pathname.split('/').filter(Boolean).pop() || '';
  const set = Object.keys(overrides).find(id => new RegExp('(?:^|-)' + id + '(?:-|$)').test(handle));
  if (!set && !sixCaptionReplacements[handle]) return;
  const copy = overrides[set] || {hero:null,life:null};
  const apply = () => {
    const root = [...document.querySelectorAll('[id^="GOB"]')].find(el => el.querySelector('h2'));
    if (!root) return;
    const replace = (heading, parts) => {
      if (!heading || !parts) return;
      const em = heading.querySelector('em');
      if (!em) return;
      const lead = [...heading.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
      if (!lead) return;
      lead.nodeValue = parts[0];
      em.textContent = parts[1];
    };
    replace(root.querySelector('h2'), copy.hero);
    replace(root.querySelector('h2[id*="evening"], .one-evening .life-copy h2'), copy.life);
    const details = [...root.querySelectorAll('section')][1];
    const cards = details ? [...details.querySelectorAll('article')].filter(card => card.querySelector('h3')) : [];
    const keepProperNames = value => value
      .replace(/\bfifa\b/gi, 'FIFA')
      .replace(/\bf1\b/gi, 'F1')
      .replace(/\bferrari\b/gi, 'Ferrari')
      .replace(/\bleclerc\b/gi, 'Leclerc')
      .replace(/\bsnoopy\b/gi, 'Snoopy')
      .replace(/\bhogwarts\b/gi, 'Hogwarts')
      .replace(/\bgreat hall\b/gi, 'Great Hall');
    const titleCase = value => value.split(/(\s+)/).map((word, index) => {
      if (!word.trim()) return word;
      if (index && /^(a|an|the|in|at|of|for|to|and|from|by|on|with)$/i.test(word)) return word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
    cards.forEach((card, index) => {
      const title = card.querySelector('h3');
      const source = title.textContent.trim();
      if (set && /\p{L}/u.test(source) && source === source.toUpperCase()) {
        let revised = cards.length === 6 ? titleCase(source) : source.charAt(0) + source.slice(1).toLowerCase();
        revised = keepProperNames(revised);
        if (set === '71043' && index === 1) revised = 'Window welcome';
        title.textContent = revised;
      }
      const revisedCaption = captionPolish[set]?.[index] || captionOverrides[set]?.[index];
      const caption = card.querySelector('p');
      if (revisedCaption && caption) caption.textContent = revisedCaption;
      const sixReplacement = cards.length === 6 ? ((window.matchMedia('(max-width: 760px)').matches && sixCaptionMobileReplacements[handle]?.[index]) || sixCaptionReplacements[handle]?.[index]) : null;
      if (sixReplacement && caption) caption.textContent = sixReplacement;
    });
  };
  apply();
  document.addEventListener('shopify:section:load', apply);
  if (sixCaptionMobileReplacements[handle]) window.addEventListener('resize', apply);
})();